import type { TUIElement } from '@ballerine/common';

import { useEvents } from '../useEvents';
import { useMount } from '../useMount';

export const useMountEvent = (element: TUIElement) => {
  const { sendEvent } = useEvents(element);

  useMount(() => sendEvent('onMount'));
};
